















































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { atributoDaVariante, corTamDoXProd } from '@/usecases/importacao-de-notas/importacaoHelpers'

const ORDEM_TAM = ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XGG', 'XXGG', 'XXG', '3G', '4G', '5G', '6G', 'G1', 'G2', 'G3', 'G4']

/**
 * De-para visual (arrastar + clicar) entre os itens da NF e as variantes da grade.
 * Ao vincular, grava EAN + quantidade da linha da NF na variante (itemDaNotaIdx).
 */
@Component
export default class DeParaVariantesDaNota extends Vue {
	@Prop({ type: Array, default: () => [] }) variantes!: any[]
	@Prop({ type: Array, default: () => [] }) itensDaNota!: any[]

	selecionado: number | null = null

	get ativo(): number | null {
		return this.selecionado
	}

	get tamAtivo(): string {
		if (this.ativo == null) return ''
		const linha = this.itensDaNota[this.ativo]
		return linha ? corTamDoXProd(linha.nota.xProd).tam : ''
	}

	atributo(v: any, nome: string): string {
		const val = atributoDaVariante(v, nome)
		return val === '—' ? '' : val
	}

	get cores(): string[] {
		const set: string[] = []
		this.variantes.forEach(v => { const c = this.atributo(v, 'Cor'); if (c && !set.includes(c)) set.push(c) })
		return set.length ? set : ['—']
	}

	get tamanhos(): string[] {
		const set: string[] = []
		this.variantes.forEach(v => { const t = this.atributo(v, 'Tamanho'); if (t && !set.includes(t)) set.push(t) })
		return set.sort((a, b) => this.rankTam(a) - this.rankTam(b))
	}

	rankTam(t: string): number {
		const i = ORDEM_TAM.indexOf(String(t).toUpperCase())
		if (i >= 0) return i
		const n = parseInt(t, 10)
		return isNaN(n) ? 2000 : 1000 + n
	}

	celula(cor: string, tam: string): any {
		return this.variantes.find(v => this.atributo(v, 'Cor') === cor && this.atributo(v, 'Tamanho') === tam)
	}

	ehVinculada(v: any): boolean {
		return !!v && v.itemDaNotaIdx != null
	}

	get naoVinculados() {
		const usados = new Set(this.variantes.filter(v => v.itemDaNotaIdx != null).map(v => v.itemDaNotaIdx))
		return this.itensDaNota
			.map((linha: any, idx: number) => {
				const { cor, tam } = corTamDoXProd(linha.nota.xProd)
				const ean = linha.nota.cEAN && linha.nota.cEAN !== 'SEM GTIN' ? linha.nota.cEAN : ''
				return { idx, cor, tam, qtd: Number(linha.nota.qCom) || 0, ean }
			})
			.filter(nf => !usados.has(nf.idx))
	}

	get vinculadosCount(): number {
		return this.variantes.filter(v => v.itemDaNotaIdx != null).length
	}

	get restantes(): number {
		return this.itensDaNota.length - this.vinculadosCount
	}

	selecionar(idx: number) {
		this.selecionado = this.selecionado === idx ? null : idx
	}

	onClickCelula(v: any) {
		if (this.ehVinculada(v)) {
			this.desvincular(v)
			return
		}
		if (this.selecionado != null) {
			this.vincular(v, this.selecionado)
			this.selecionado = null
		}
	}

	vincular(v: any, nfIdx: number) {
		// se a célula já tinha vínculo, libera o item da NF anterior automaticamente
		const linha = this.itensDaNota[nfIdx]
		if (!v || !linha) return
		const ean = linha.nota.cEAN && linha.nota.cEAN !== 'SEM GTIN' ? linha.nota.cEAN : null
		if (ean) this.$set(v, 'eans', [ean])
		this.$set(v, 'quantidadeImportacao', Number(linha.nota.qCom) || 0)
		this.$set(v, 'itemDaNotaIdx', nfIdx)
		this.$emit('alterado')
	}

	desvincular(v: any) {
		this.$set(v, 'itemDaNotaIdx', null)
		this.$set(v, 'quantidadeImportacao', 0)
		this.$emit('alterado')
	}
}
